import {
  Directive,
  AfterViewInit,
  OnDestroy,
  Input,
  SimpleChanges,
  OnChanges,
  OnInit,
  HostListener,
} from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { BASE_INQUIRY_CALENDAR_DAY_COLUMN_WIDTH } from '../../modules/inquiry/_const/base-inquiry-calendar.const';
import { BaseInquiryScrollService } from '../../modules/inquiry/_services/base-inquiry-scroll.service';
import { takeUntil, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { elementIsVisibleInViewport } from '../helpers/base-is-element-visible-in-viewport';

@Directive({
  selector: '[baseInquiryHorizontalScroll]',
})
export class BaseHorizontalScrollDirective implements AfterViewInit, OnDestroy, OnChanges, OnInit {
  @Input() isCalendar = false;
  @Input() trackList: any[] = [];

  private calendarOffset = 0;
  private destroy$ = new Subject<boolean>();

  constructor(private viewPort: CdkVirtualScrollViewport, private baseInquiryScrollService: BaseInquiryScrollService) {}

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.recalculateCalendarScroll();
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (elementIsVisibleInViewport(this.viewPort.getElementRef().nativeElement, true, 300)) {
      this.viewPort.scrollToIndex(this.calendarOffset);
    }
  }

  ngOnInit() {
    this.viewPort.scrolledIndexChange.pipe(takeUntil(this.destroy$), debounceTime(300)).subscribe((index) => {
      if (index !== this.calendarOffset) {
        this.viewPort.scrollToIndex(this.calendarOffset);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.trackList && !changes?.trackList?.firstChange) {
      this.recalculateCalendarScroll();

      if (elementIsVisibleInViewport(this.viewPort.getElementRef().nativeElement, true)) {
        requestAnimationFrame(() => {
          this.viewPort.scrollToIndex(this.calendarOffset);
        });
      }
    }
  }

  ngAfterViewInit(): void {
    this.scrollAction();
    this.recalculateCalendarScroll();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private recalculateCalendarScroll() {
    if (this.isCalendar) {
      this.setVisiblePartWidth();
      this.viewPort.checkViewportSize();
    }
  }

  private scrollAction() {
    if (elementIsVisibleInViewport(this.viewPort.getElementRef().nativeElement, true)) {
      requestAnimationFrame(() => {
        this.viewPort.scrollToIndex(this.calendarOffset);
      });
    }

    this.baseInquiryScrollService.scrollOffset$
      .pipe(takeUntil(this.destroy$), distinctUntilChanged())
      .subscribe((value) => {
        this.calendarOffset = value;

        if (elementIsVisibleInViewport(this.viewPort.getElementRef().nativeElement, true)) {
          requestAnimationFrame(() => {
            this.viewPort.scrollToIndex(value, 'smooth');
          });
        }
      });
  }

  private setVisiblePartWidth() {
    this.baseInquiryScrollService.setVisibleDatesValue(
      Math.floor(this.viewPort.getElementRef().nativeElement.offsetWidth / BASE_INQUIRY_CALENDAR_DAY_COLUMN_WIDTH)
    );
  }
}
